import { render, staticRenderFns } from "./SegmentCommercial.vue?vue&type=template&id=481d4d4a"
import script from "./SegmentCommercial.vue?vue&type=script&lang=js"
export * from "./SegmentCommercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports